import { render } from "./SWUpdatePrompt.vue?vue&type=template&id=6b1a439f"
import script from "./SWUpdatePrompt.vue?vue&type=script&lang=js"
export * from "./SWUpdatePrompt.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__